<template>
  <div class="activity-operator">
    <hot-spot v-if="!showBtnStep" @btnClick="hotSpotClick" />
    <div v-if="showBtnStep" class="visual has-count">
      <div class="sub" :style="{ width: '0.48rem' }">
        <hot-spot :right="0" @btnClick="catchMinusTap" />
        <maple-icon size="0.32rem" name="jianhao" color="#FE2A42" />
      </div>
      <div class="num" @click.stop="keyboardTap">
        {{ count }}
      </div>
      <div class="add" :style="{ width: '0.48rem' }">
        <hot-spot :left="0" @btnClick="catchPlusTap" />
        <maple-icon
          size="0.32rem"
          name="jiahao"
          :color="count < availableAmount ? '#FE2A42' : '#BFBFBF'"
        />
      </div>
    </div>
    <btn-config
      v-if="!showBtnStep"
      :width="1.6"
      :has-bg-img="activityInfo.status === 1"
      :bg-start-color="'#F65D2A'"
      :bg-end-color="'#FE2A42'"
      :border-color="
        activityInfo.status === 0 && hasSetRemind ? '#BFBFBF' : THEME_COLOR
      "
      :has-border="hasBorder"
      :font-color="btnColor"
      :text="btnText"
      :icon-size="'16px'"
    />
  </div>
</template>

<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
import { THEME_COLOR } from '@/defines/environment/config'

export default {
  name: 'AcitivityComp',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    activityInfo: {
      type: Object,
      default: () => {}
    },
    hasSetRemind: {
      type: Boolean,
      default: false
    },
    showCount: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    availableAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      THEME_COLOR
    }
  },
  computed: {
    hasBorder() {
      return this.activityInfo.status === 0
    },
    btnText() {
      let text = ''
      if (this.activityInfo.status === 0) {
        // 秒杀未开始
        text = this.hasSetRemind ? '已设置提醒' : '提醒我'
      } else if (this.activityInfo.status === 1) {
        // 秒杀进行中
        text = '立即抢购'
      } else {
        text = '已结束'
      }
      return text
    },
    btnColor() {
      let fontColor = ''
      if (this.activityInfo.status === 0) {
        fontColor = this.hasSetRemind ? '#BFBFBF' : THEME_COLOR
      } else if (this.activityInfo.status === 1) {
        fontColor = '#fff'
      } else {
        fontColor = '#8C8C8C'
      }
      return fontColor
    },
    showBtnStep() {
      return this.count && this.activityInfo.status === 1
    }
  },
  methods: {
    hotSpotClick() {
      if (this.activityInfo.status === 0) {
        this.$emit('seckillRemind')
      } else if (this.activityInfo.status === 1) {
        this.$emit('add')
      }
    },
    catchMinusTap() {
      this.$emit('sub')
    },
    catchPlusTap() {
      this.$emit('add')
    },
    keyboardTap() {
      this.$emit('keyboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-operator {
  position: relative;
}
.operator {
  width: 1.2rem;
  height: 0.48rem;

  background-image: linear-gradient(to right, #f65d2a, #fe2a42);
  border-radius: 0.24rem;
  border: 1px solid #999999;

  border-style: none;

  font-size: 0.22rem;
  color: #fff;
  box-sizing: border-box;
  @include flex-row-center;
  &.remind {
    background-image: none;
    border: 1px solid #0daf52;

    color: #0daf52;

    &.has-set-remind {
      border: 1px solid #d9d9d9;

      color: #d9d9d9;
    }
  }
}
.activity-end {
  margin-right: 0.2rem;

  font-size: 0.24rem;
  color: #bfbfbf;
}
.visual {
  height: 0.52rem;

  background-color: #f5f5f5;

  flex: none;
  @include flex(row, flex-start, center, nowrap);

  &.has-count {
    border-radius: 0.26rem;
  }

  .sub,
  .num,
  .add {
    position: relative;

    height: 0.52rem;

    text-align: center;
    @include flex-column-center;
  }

  .num {
    width: 0.64rem;

    font-size: 0.26rem;
    font-weight: bold;
    color: #262626;
    &:after {
      display: block;

      position: absolute;
      top: -0.16rem;
      right: 0;
      bottom: -0.16rem;
      left: 0;

      content: '';
    }
  }

  .sub,
  .add {
    width: 0.48rem; // 长32px(.64rem) 正常24px(.48rem) !! 待对接
  }
}
</style>
